<template>
  <div>
    <!--   login abschnitt -->
    <v-card
      id="idLoginDialog"
      class="mx-auto"
      persistent
      max-width="600px"
      min-width="300px"
    >
      <div>
        <v-tabs
          v-model="tab"
          show-arrows
          background-color="primary"
          icons-and-text
          dark
          grow
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="i in tabs" :key="i.name" :to="i.to">
            <v-icon large>{{ i.icon }}</v-icon>
            <div class="caption py-1">{{ i.name }}</div>
          </v-tab>
          <v-tab-item> </v-tab-item>
          <v-tab-item>
            <v-card class="px-4">
              <v-card-text>
                <v-form ref="PWResetForm" v-model="validForm" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        id="reset_loginEmail"
                        ref="reset_loginEmail"
                        v-model="loginEmail"
                        :rules="loginEmailRules"
                        label="E-Mail"
                        prepend-icon="mdi-email"
                        clearable
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="6" xsm="12"> </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                      <v-btn
                        id="reset_submit"
                        x-large
                        block
                        :disabled="!validForm"
                        color="primary"
                        @click="pwResetCall"
                        >SENDEN</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-card>
    <!--   login abschnitt -->
  </div>
</template>

<style scoped></style>

<script>
import SettingsStore from "../store/SettingsStore";

export default {
  components: {},
  data: () => ({
    tab: 1,
    tabs: [
      { name: "Login", to: "/login", icon: "mdi-account" },
      { name: "Passwort vergessen", icon: "mdi-lock-reset" },
    ],
    validForm: true,
    loginEmail: "",
    loginPassword: "",
    geburtsdatum: "",
    password: "",
    pw_vergleich: "",
    pw_angezeigt: false,
    loginEmailRules: [
      (v) => !!v || "Erforderlich",
      (v) => /.+@.+\..+/.test(v) || "E-mail muss gültig sein",
      //v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail muss gültig sein'
    ],
    rules: {
      required: (value) => !!value || "Erforderlich.",
      min: (v) => (v && v.length >= 8) || "Mindestens 8 Zeichen",
    },
    snackbar: {},
  }),
  computed: {
    passwordMatch() {
      return () =>
        this.password === this.pw_vergleich ||
        "Passwörter müssen identisch sein";
    },
  },
  mounted() {
    this.startupFocus();
  },
  methods: {
    startupFocus() {
      this.$nextTick(() => {
        this.$refs.reset_loginEmail.focus();
      });
    },
    pwResetCall() {
      if (this.$refs.PWResetForm.validate()) {
        //Feld ist eingetragen...
        this.$emit("loadingEvent", { show: true });

        var url = SettingsStore.data.config.apiBaseURL + "/pw-reset-request"; //wo das backende pw-reset-request sitzt
        var data = { loginEmail: this.loginEmail };
        var headers = {
          "Content-type": "application/json",
          Accept: "application/json",
        };
        var config = { timeout: 30000 };

        this.axios
          .post(url, data, headers, config)
          .then((response) => {
            this.$emit("loadingEvent", { show: false });
            if (response.data.result.success) {
              this.snackbar = {
                text: "Ein Passwort Reset E-Mail wurde verschickt.</br>Bitte prüfen Sie ihren Posteingang.",
                color: "success",
                show: true,
              };
              this.$emit("snackbarEvent", this.snackbar);
            } else {
              this.snackbar = {
                text: response.result.statustext,
                color: "error",
                show: true,
              };
            }
          })
          .catch((error) => {
            this.$emit("loadingEvent", { show: false });
            console.log(error.response);
            this.snackbar = {
              text: "Ein Fehler ist aufgetreten.<br/>Bitte versuchen Sie es erneut.<br/>",
              color: "error",
              show: true,
            };
            this.$emit("snackbarEvent", this.snackbar);
          });
      }
    },
  },
};
</script>
